import { graphql, useStaticQuery } from 'gatsby';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

type PostFrontMatterProps = {
  title: string;
  date: Date;
  slug: string;
  code: string;
  published: boolean;
  featured?: boolean;
  category: string;
  tags: string[];
  featuredImage:FileNode;
  embeddedImagesLocal: [FileNode];
  description: string;
};

export interface PostCardProps {
  id: string;
  frontmatter: PostFrontMatterProps;
}

const postQuery = () => {
  const data = useStaticQuery(graphql`
    query PostQuery {
      blogPosts: allMdx(
        sort: { frontmatter: { date: ASC } }
        filter: { frontmatter: { category: { eq: "post" } } }
        limit: 1000
      ) {
        postItems: nodes {
          id
          frontmatter {
            title
            date(formatString: "MMM Do, YYYY")
            description
            category
            tags
            published
            featured
            slug
            template
            featuredImage {
              childImageSharp {
                gatsbyImageData(width: 1200
                placeholder: BLURRED
                )
              }
            }
            embeddedImagesLocal {
              childImageSharp {
                gatsbyImageData(width: 200
                placeholder: BLURRED
                )
              }
            }
          }
          internal {
            contentFilePath
          }
        }
      }
    }
  `);
  const posts: PostCardProps[] = data.blogPosts.postItems;
  return { posts };
};

export { postQuery };
